/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { IVisitor } from '../visitors/IVisitor';
import { IVisitable } from './IVisitable';
import { NodePath } from './NodePath';
import { ValidationProblemSeverity } from './ValidationProblemSeverity';

/**
 * Constructor.
 * @param {string} errorCode
 * @param {NodePath} nodePath
 * @param {string} property
 * @param {string} message
 * @param {ValidationProblemSeverity} severity
 * @class
 * @author eric.wittmann@gmail.com
 */
export class ValidationProblem implements IVisitable {
    public errorCode : string;

    public nodePath : NodePath;

    public property : string;

    public message : string;

    public severity : ValidationProblemSeverity;

    public constructor(errorCode : string, nodePath : NodePath, property : string, message : string, severity : ValidationProblemSeverity) {
        if(this.errorCode===undefined) this.errorCode = null;
        if(this.nodePath===undefined) this.nodePath = null;
        if(this.property===undefined) this.property = null;
        if(this.message===undefined) this.message = null;
        if(this.severity===undefined) this.severity = null;
        this.errorCode = errorCode;
        this.nodePath = nodePath;
        this.property = property;
        this.message = message;
        this.severity = severity;
    }

    /**
     * @see io.apicurio.datamodels.core.models.IVisitable#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        visitor.visitValidationProblem(this);
    }
}
ValidationProblem["__class"] = "io.apicurio.datamodels.core.models.ValidationProblem";
ValidationProblem["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




